/* eslint-disable no-shadow */
export enum CompanyRole {
	ADMIN = 'ADMIN',
	CLIENT = 'CLIENT',
}

export enum CompanyStatus {
	ACTIVE = 'active',
	TRIAL = 'trial',
	CANCELLED = 'cancelled',
}
